<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Аудиолекции
    </h1>
    <CommonComplexFiltering
      v-if="false"
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="audioRubrics?.data?.value"
      is-centuries-disabled
      :filters-active="filters"
    />
    <!-- :sources-list="sources?.data?.value" -->
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="lecture in audioLectures?.data?.value?.data"
        :key="lecture.id"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        :data="lecture"
        is-small-title
        :title-length="60"
      >
        <template #cover>
          <AudioStandAlonePlayButton
            v-if="lecture?.path"
            :data="lecture"
            class="absolute left-1/2 top-1/2 z-40 hidden -translate-x-1/2 translate-y-1/2 md:flex"
            @on-play="setList()"
          >
          </AudioStandAlonePlayButton>
        </template>
      </MainPageCardsReworkedBaseCard>
    </div>

    <BaseThePagination :entity="audioLectures" />

    <!-- <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="audioLectures.hasNextPage.value"
        text="Показать еще"
        @click="audioLectures.fetchNextPage()"
      />
    </div> -->
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

const audioStore = useAudioStore();

const filters = computed(() => {
  return {
    category: route.query?.category,
    source: route.query?.source,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
// const { sources } = useSources({ main: true });
const { audioLectures, resetPage } = useAudioLectures({
  filters,
  per_page: 9,
  page,
});
const { audioRubrics } = useAudioCategories();

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const setList = () => {
  audioStore.setCurrentCategoryList('lectures');
  audioStore.setCurrentAudioList(audioLectures?.data?.value);
};

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'Аудиолекции по истории РФ для школьников и студентов | Слушать на Федеральном портале Истории России',
  ),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Аудиолекции истории России от выдающихся профессоров и историков нашей страны. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>

<style lang="scss"></style>
